import { Button } from '../Button/BTTButton'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import './RunBar.scss'

const RunBar = ({ onRun, onNextStep, complete = false }) => {
  return (
    <div
      className={classNames('c-runbar', { 'c-runbar--success': !!complete })}
    >
      {complete && (
        <div className="c-runbar__success-message">Step Complete!</div>
      )}

      <div className="c-runbar__controls">
        <Button
          outerClassName="c-runbar__button"
          icon="play_arrow"
          iconPosition="right"
          variant="3d"
          onClick={onRun}
          text={'Run code'}
          textAlways
          type={complete ? 'success-secondary' : 'primary'}
        />

        {complete && (
          <Button
            outerClassName="c-runbar__button"
            onClick={onNextStep}
            text={'Continue'}
            variant="3d"
            textAlways
            type="success"
          />
        )}
      </div>
    </div>
  )
}

RunBar.propTypes = {
  onRun: PropTypes.func.isRequired,
  onNextStep: PropTypes.func.isRequired,
  complete: PropTypes.bool,
}

export default RunBar
